<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :color="primary_code"></loading>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- Title-->
    <header-component :headerTitle="headerText" />
    <v-row justify="center">
      <v-dialog v-model="downloadDialog" persistent max-width="364px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0">
            <v-card-title>
            <v-row class="ma-1">
              <span>Download</span>
              <v-spacer></v-spacer>
              <!-- <v-btn icon @click="downloadDialog = false"> -->
                <v-icon @click="downloadDialog = false">mdi-close</v-icon>
              <!-- </v-btn> -->
            </v-row>
            </v-card-title>
          </v-card>
          <v-card-text class="download-email">
            <v-row>
              <v-col cols="12" sm="4" md="12">
                <v-text-field label="Email Id" variant="outlined" v-model="email_id" type="text" :rules="emailRules" @input="validateEmail"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" class="text-none" size="large" color="primary" @click="downloadDialog = false">Cancel</v-btn>
             <v-btn variant="flat" class="text-none" size="large" color="primary" @click="downloadDocument('submit')" :disabled="!isEmailValid || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Header -->
    <v-card class="v-card-100 mt-6">
      <v-tabs v-model="tab_index" color="primary">
          <v-tab style="text-transform:none!important;" @click="loadData(tab, 'tab_clicked')" v-for="(tab, index) in tabs"
            :key="`${tab+index}`" class="component-tab-heading tab-color">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>
    <!-- seacrh, action button and filter -->
    <v-card-title class="action-style">
      <!-- Search fields -->
      <v-row class="ma-1">
        <v-col cols="3" sm="3" class="pb-0 pt-4">
          <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="search_tag" :label="search_label" v-no-edge-space style="max-width: 270px;" variant="outlined" v-on:keyup.enter="loadData(active_tab)" ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-card-actions style="margin-top: 2px; padding-top: 0px; padding-bottom: 0px;">
          <v-btn variant="flat" class="mr-2 custum-button text-none" color="primary" v-if="active_tab == 'Attribute Master'" @click="addNewAttribute" style="min-height: 56px;">Create New Attribute Master</v-btn>
          <!-- <v-btn variant="flat" class="mr-2 mt-2" color="primary" @click="downloadDocument">Download</v-btn> -->
          <v-btn class="mr-2 custum-button text-none" v-if="selected.length > 0" @click="downloadDocument('selected')" color="primary" variant="flat" style="min-height: 56px;">Download</v-btn>
          <v-btn class="mr-2 custum-button text-none" v-if="selected.length === 0" @click="openPopup" color="primary" variant="flat" style="min-height: 56px;">Download</v-btn>
          <v-btn class="mr-2 custum-button text-none" color="primary" @click="navigateToFileUpload" variant="flat" style="min-height: 56px;">Upload</v-btn>
          <v-btn class="mr-2 custum-button text-none" v-if="active_tab !== 'Price Master'" color="primary" variant="flat" @click="addItem" style="min-height: 56px;">Add</v-btn>
          <v-btn class="mr-2 custum-button text-none" v-if="active_tab === 'Price Master'" variant="flat" :disabled="(selected.length !== 1)" color="primary" @click="addItem" style="min-height: 56px;">Edit</v-btn>
          <!-- <v-btn class="mr-2 custum-button" color="primary" variant="flat" v-if="active_tab != 'BOM Master'" @click="editItem">Edit</v-btn> -->
        </v-card-actions>
      </v-row>
      <!-- Filter -->
      <!-- <v-expansion-panels class="custom-control_outlined" ref = "filterPopupRef" readonly style="max-width: 150px; margin-bottom: 28px; min-height: 56px;">
        <v-expansion-panel variant="outlined" @click="filterListOfButtons" >
          <v-expansion-panel-header>Filter
            <template v-slot:actions>
              <v-icon color="primary">
                mdi-menu-down
              </v-icon>
            </template>
          </v-expansion-panel-header>
        </v-expansion-panel>
      </v-expansion-panels> -->
    </v-card-title>
    <v-row class="update-marp-style ma-1" v-if="active_tab === 'Price Master'">
      <div class="inside-row-style">
        <span style="margin-right:50px">Liquidation benchmark price: <b>MRP</b> <v-icon v-if="!liquidation_benchmark_price" class="pencil-style"  @click="openLiquidationBMP('Liquidation BMP')">mdi-pencil</v-icon></span> 
        <span>Recovery benchmark price: <b>Purchase Price</b> <v-icon v-if="!recovery_benchmark_price" class="pencil-style" @click="openLiquidationBMP('Recovery BMP')">mdi-pencil</v-icon></span>
      </div>
    </v-row>
    <div v-if="active_tab == 'Category Master' && !isCategorySelected">
      <div>
        <p style="text-align: center;">Nothing To Show Here.</p>
        <v-btn color="primary" @click="defineCategoryFunc" style="margin: 4% 43% 28%;">Define Category Node</v-btn>
      </div>
    </div>
    <div v-else>
      <div v-if="active_tab !== 'BOM Master'">
        <v-layout column>
          <!-- <v-flex md6 style="overflow:auto"> -->
          <v-data-table 
            :dense="true" 
            :search="search" 
            v-model="selected" 
            show-select 
            disable-pagination 
            :hide-default-footer="true" 
            :headers="headers" 
            :items="table_data" 
            :loading="loading"
            fixed-header
            :items-per-page="pageSize"
            height="100%" 
            :style="dataTableStyle"
            return-object
             loading-text="Loading Data... Please wait" class="elevation-1">
             <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else-if="header.key === 'images' &&  item.images.length">
                <a @click.prevent="openImagePopup(item)" style="text-decoration: underline; color:#1976d2; cursor: pointer;">
                  View Image
                </a>
              </span>
              <span v-else>-</span>
            </template>

              <!-- <template v-for="(header, index) in headers" :key="index" v-slot:[`item.${header.key}`]="{ item }">
                  <span v-if="item[header.key] !== null && item[header.key] !== ''">
                    {{ item[header.key] }}
                  </span>
                  <span v-else>
                    <span>-</span>
                  </span>
              </template> -->
              <!-- <template #[`item.images`]="{ item }">
                <a style="color: #1976d2; cursor: pointer;" v-if="item.images.length" @click="openImagePopup(item)">
                    <u>View Image</u>
                  </a>
                <span v-if="!item.images.length">-</span>
              </template> -->
              <template #bottom></template>
            </v-data-table>
          </v-layout>
            <div>
            <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    :active_tab="active_tab"
                    class="mt-2 mb-2"
                />    
              </div>      
        <!-- </v-flex> -->
      </div>
      <div v-else>
        <v-layout column>
          <!-- <v-flex md6 style="overflow:auto"> -->
            <v-col>
              <div class="table-container" style="overflow-x: auto; width: 100%;">
                <table style="min-width: 1400px;">
                  <thead>
                    <tr>
                      <th style="width: 5%;z-index: 10;" class="header_border"><v-checkbox v-model="select_all" class="ma-0" hide-details @change="update_all_selectall"/></th>
                      <th style="width: 8%;" class="header_border">Article ID</th>
                      <th style="width: 17%;padding-right:12px;" class="header_border">Article Description</th>
                      <th style="width: 13%;" class="header_border">BOM Article ID</th>
                      <th style="width: 18%;padding-right:12px;" class="header_border">BOM Article Description</th>
                      <th style="width: 13%;" class="header_border">UOM</th>
                      <th style="width: 13%;" class="header_border">Quantity</th>
                      <th style="width: 13%;" class="header_border">Production Cost</th>
                    </tr>
                  </thead>
                  <tbody style="overflow-y: auto;"  v-for="(row, r_index) in bom_result" :key="r_index">
                    <tr v-for="(item, c_index) in row.bom_data" :key="c_index" class="row_data">
                      <td :class="c_index == 0 ? 'top_border' : ''">
                        <v-checkbox v-model="item.show_select" v-if="c_index == 0" class="ma-0"  @change="selectItem(item, row)" hide-details/>
                      </td>
                      <td :class="c_index == 0 ? 'top_border' : ''">{{ c_index == 0 ? row.article_id : "" }}</td>
                      <td :class="c_index == 0 ? 'top_border' : ''" class="pr-3">{{ c_index == 0 ? row.article_description : "" }}</td>
                      <td :class="c_index == 0 ? 'top_border' : ''">{{ item.child_sku_code }}</td>
                      <td :class="c_index == 0 ? 'top_border' : ''" class="pr-3">{{ item.child_sku_description }}</td>
                      <td :class="c_index == 0 ? 'top_border' : ''">{{ item.uom ? item.uom : '-' }}</td>
                      <td :class="c_index == 0 ? 'top_border' : ''">{{ item.quantity }}</td>
                      <td :class="c_index == 0 ? 'top_border' : ''">
                        <span v-if=" c_index == 0 && row.production_cost && row.production_cost !== 'N/A' " >₹</span >
                        {{ c_index == 0 ? row.production_cost ? row.production_cost : "-" : "" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>

            <!-- <v-data-table 
              :dense="true" 
              :search="search" 
              v-model="selected" 
              show-select 
              single-select
              disable-pagination 
              :hide-default-footer="true" 
              :headers="headers" 
              :items="table_data" 
              :loading="loading"
              fixed-header
              height="100%" 
              loading-text="Loading Data... Please wait" class="elevation-1">
                <template v-slot:item.data-table-select="{ item }">
                    <v-checkbox v-if="item.article_id" v-model="item.show_select" hide-details @change="selectItem(item)" class="mt-0"/>
                  </template>
                <template v-for="(header, index) in headers" v-slot:[`item.${header.value}`]="{ item }">
                  <span v-if="item[header.value] !== null && item[header.value] !== ''">
                    {{ item[header.value] }}
                  </span>
                </template>
            </v-data-table>           -->
          <!-- </v-flex> -->
        </v-layout>
        <!-- pagination display -->
      <PaginationComponent
                    :pageSize="BomPageSize"
                    :pageSizes="BomPageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-2"
                />
      </div>
    </div>
    <v-row justify="center">
      <v-dialog v-model="categoryPopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="mb-5 d-flex align-center">
            <span>Define Category Node</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="categoryPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <div v-for="item in category_details">
              <v-text-field color="primary" variant="outlined" label="Enter the Category Node" v-model="item.category_node"></v-text-field>
            </div>
            <span style="text-decoration: underline;color:#0d6efd; cursor: pointer; " @click="addCategoryNode">ADD MORE</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" class="text-none" variant="outlined" color="primary" @click="categoryPopup = false">Cancel</v-btn>
            <v-btn size="small" class="text-none" variant="flat" color="primary" @click="categoryNodeSubmit">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="addItemPopup" persistent max-width="736px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>{{ add_item_title }}</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="addItemPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-form ref="addFormData">
              <v-row v-if="active_tab == 'Category Master'">
                <div v-for="item in category_details" style="margin:0px">
                  <v-text-field color="primary" v-model="item.value" :label="item.label_name" hide-details style="width:300px; margin:20px" variant="outlined"></v-text-field>
                </div>
                <div>
                <v-text-field color="primary" v-model="category_node" label="Enter Category Code *" hide-details style="width: 300px; margin:20px" variant="outlined"></v-text-field>
                </div>
              </v-row>
              <v-row  v-if="active_tab == 'SKU Master'">
                <v-col cols="6" class="pb-0 pt-7">
                  <v-text-field color="primary" label="Article ID *" v-model="article_id" variant="outlined" ></v-text-field>
                </v-col>
                <v-col cols="6" class="pb-0 pt-7">
                  <v-text-field color="primary" label="Brand *" v-model="brand" variant="outlined"></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field color="primary" label="Article Description *" v-model="article_desc" variant="outlined"></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-autocomplete color="primary" prepend-inner-icon="mdi-magnify" label="Select Category Code *" v-model="category_code" :items = "category_list" variant="outlined"></v-autocomplete>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-autocomplete color="primary" label="Select Type *" v-model="selected_type" :items = "type_list" variant="outlined"></v-autocomplete>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-autocomplete color="primary" label="Organization *" v-model="organization" :items = "org_list" variant="outlined"></v-autocomplete>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field color="primary" label="Attach Image Link" v-model="img_link" variant="outlined"></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field color="primary" label="Enter HSN Code" v-model="hsn_code" variant="outlined"></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-autocomplete color="primary" label="Select UOM *" v-model="select_uom" :items = "uom_list" variant="outlined"></v-autocomplete>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-autocomplete color="primary" label="It's Serialized *" v-model="serializes" :items="serial_list" variant="outlined"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-if="active_tab == 'Attribute Master'">
                <div v-for="item in attribute_masters" style="margin:0px">
                    <v-text-field color="primary" v-model="item.code" :label="item.title" hide-details style="width:300px; margin:20px" variant="outlined"></v-text-field>
                </div>
              </v-row>
              <v-row v-if="active_tab == 'Price Master'"> 
              <!-- <v-text-field color="primary" v-model="item.value" :label="item.text" hide-details style="width:300px; margin:20px" variant="outlined" :disabled="item.disabled"></v-text-field>            -->
                  <v-col cols="6" class="pb-0">
                  <v-text-field color="primary" label="Enter Article ID" v-model="article_id" variant="outlined" disabled></v-text-field>
                </v-col>
                <v-col cols="6" class="pb-0">
                  <v-text-field color="primary" label="Category Code" v-model="category_code_price" variant="outlined" disabled></v-text-field>
                </v-col>
                <v-col cols="6" class="pb-0" style="margin-top:-10px">
                  <v-text-field color="primary" type="number" label="Enter mrp" v-model="mrp" variant="outlined"></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field color="primary" type="number" label="Enter ASP" v-model="asp" variant="outlined"></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field color="primary" type="number" label="Enter MAP" v-model="map" variant="outlined"></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field color="primary" type="number" label="Enter Rent Rate/Month" v-model="rent" variant="outlined"></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field color="primary" type="number" label="Security Deposit" v-model="security_deposit" variant="outlined"></v-text-field>
                </v-col>
              </v-row>
              <div v-if="active_tab == 'BOM Master'">
                <v-row>
                  <v-col cols="6" class="pb-0 pt-7">
                    <v-autocomplete color="primary" prepend-inner-icon="mdi-magnify" label="Select the Article ID *" v-model="article_id_bom" :items="articleId_list" variant="outlined" item-title="code" item-value="id" @keyup="getBOMFilterData($event, 'article')"></v-autocomplete>
                  </v-col>
                  <v-col cols="6" class="pb-0 pt-7">
                    <v-text-field color="primary" label="Enter the Production Cost (₹)" v-model="production_cost" variant="outlined"></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-for="(item, index) in bom_details">
                  <v-col cols="6" class="pb-0">
                    <v-autocomplete color="primary" prepend-inner-icon="mdi-magnify" label="Select BOM *" v-model="item.selected_bom" :items="bom_list" variant="outlined" item-title="code" item-value="id" @keyup="getBOMFilterData($event, 'bom_article')" @update:modelValue="getUOMValue(item.selected_bom, index)"/>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field color="primary" label="UOM *" v-model="item.uom" variant="outlined"/>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field color="primary" label="Enter the Quantity *" v-model="item.quantity" variant="outlined"/>
                  </v-col>
                  <v-col cols="6" class="pb-0"></v-col>
                  <div v-if="index != bom_details.length-1" style="color:red; text-decoration: underline; padding-left:24px" @click="deleteItem(index)">Delete</div>
                </v-row>
                <div style="color:#0d6efd; text-decoration: underline;margin-left: 12px;" @click="addMore">Add More</div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" class="text-none" variant="outlined" color="primary" @click="clearData">Cancel</v-btn>
            <v-btn size="small" class="text-none" variant="flat" color="primary" @click="submitCategoryMaster" v-if="button_action == 'add'" :disabled="!isSubmitButtonEnabled">Submit</v-btn>
            <v-btn size="small" class="text-none" variant="flat" color="primary" @click="addItemPopup = false" v-if="button_action == 'edit'">Update</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="successPopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="successPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text class="text-center">
            <span>{{ message }}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn size="small" variant="flat" color="primary" @click="cancelSuccessMessage">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
     <!-- Add New Attribute popup   -->
    <v-row justify="center">
      <v-dialog v-model="newAttributeDialog" persistent max-width="431px">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex align-center">
            <span>Add new attributes</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="newAttributeDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <v-row>
              <v-text-field color="primary" label="Enter new attributes" v-model="new_attribute" variant="outlined" class="m-3" hide-details/>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="newAttributeDialog = false">Cancel</v-btn>
            <v-btn variant="flat" color="primary" class="mb-3 text-none" @click="submitNewAttribute" :disabled="!new_attribute || number > 0">Add</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Liquidation BMP popup   -->
    <v-row justify="center">
      <v-dialog v-model="imagesPopup" persistent max-width="400px">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex align-center">
            <span>Images</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="imagesPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text class="mt-3">
            <v-row>
              <v-col v-for="(image, index) in imagesList" :key="index" cols="12">
                <div class="image-container">          
                <img :src="image" alt="No Image" class="image-rad-size"/>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="liquidationBMPPopup" persistent max-width="431px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>{{dialog_label_name}}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="liquidationBMPPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text style="padding: 0 10px">
            <v-container>
              <v-row>
                <v-autocomplete color="primary" v-model="liquidation_bmp" variant="outlined" :items="liquidation_bmp_items" label="Liquidation BMP" style="max-width: 380px;" class="m-3" hide-detail></v-autocomplete>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="liquidationBMPPopup = false">Cancel</v-btn>
            <v-btn variant="flat" color="primary"  class="mb-3 text-none" @click="updateBMPLiquidation" :disabled="!liquidation_bmp || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>
<script>
  import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
  import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  import Loading from 'vue-loading-overlay';
  // import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    components : {
      HeaderComponent,Loading
    },

    data(){
      return {
        headerText: "Item Master",
        alert : false,
        alert_type : 'info',
        alert_message : '',
        tabs : ["Category Master", "SKU Master", "Attribute Master", "Price Master", "BOM Master"],
        search_tag : '',
        active_tab : '',
        isCategorySelected : false,
        categoryPopup : false,
        category_details : '',
        addCategPopup : false,
        loading : false,
        headers : [],
        table_data : [],
        search  : '',
        page: 1,
        totalPages: 1,
        totalCount: '',
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        add_item_title : '',
        addItemPopup : false,
        bom_details : [{ selected_bom:'', uom:'', quantity:''}],
        article_id : '',
        brand : '',
        article_desc :'',
        category_code : '',
        category_list : [],
        selected_type : '',
        type_list : [],
        organization : '',
        org_list : [],
        img_link : '',
        hsn_code : '',
        select_uom : null,
        uom_list : [],
        serializes : null,
        serial_list : [],
        item_type : '',
        capacity : '',
        size : '',
        ram : '',
        hdd : '',
        processor : '',
        color : '',
        mrp : '',
        asp : '',
        map : '',
        rent : '',
        select_all : false,
        imagesPopup : false,
        production_cost : '',
        imagesList : [],
        isLoading : false,
        fullPage : true,
        bom_list : [],
        primary_code: "#0275d8",
        articleId_list : [],
        button_action : '',
        successPopup : false,
        message : '',
        selected:[],
        category_node:'',
        tab_index: 0,
        action:'',
        active_tab_condi:'',
        newAttributeDialog: false,
        new_attribute:'',
        attribute_masters:[],
        liquidationBMPPopup: false,
        liquidation_bmp_items:[],
        liquidation_bmp:'',
        dialog_label_name:'',
        price_master_form_data:[],
        article_id_bom:'',
        category_code_price:'',
        security_deposit:'',
        search_label:'',
        recovery_benchmark_price : '',
        liquidation_benchmark_price : '',
        bom_result: '',
        store_art:'',
        store_bom:'',
        downloadDialog: false,
        number:0,
        email_id: '',
        isEmailValid: true,
        emailError: '',
        BomPageSize: 10,
        BomPageSizes: [10, 20, 30],
        snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          timeout: 7500,
          title: null,
          visible: false,
                  },
      }
    },
    async created() {
      this.active_tab_condi = this.$store.state.active_tab;
      if (this.active_tab_condi === "first_tab" || !this.active_tab_condi || this.active_tab_condi === "Category Master") {
        this.tab_index = 0;
        this.loadData("Category Master");
      } else if (this.active_tab_condi === "second_tab" || this.active_tab_condi === "SKU Master") {
        this.tab_index = 1;
        this.loadData("SKU Master");
      } else if (this.active_tab_condi === "third_tab" || this.active_tab_condi === "Attribute Master") {
        this.tab_index = 2;
        this.loadData("Attribute Master");
      } else if (this.active_tab_condi === "fourth_tab" || this.active_tab_condi === "Price Master") {
        this.tab_index = 3;
        this.loadData("Price Master");
      } else if (this.active_tab_condi === "fifth_tab" || this.active_tab_condi === "BOM Master") {
        this.tab_index = 4;
        this.loadData("BOM Master");
      } else {
        this.loadData("Category Master");
      }
    },
    computed: {
      urlRule() {
        return v => !v || this.isValidUrl(v) || 'Invalid URL';
      },
      emailRules() {
        return [
          v => this.emailError || true
        ];
      },
      isSubmitButtonEnabled() {
        if (this.active_tab === 'Category Master') {
          const categoryL1 = this.category_details.find(
            item => item.original_code === 'Category L1'
          );
          const isCategoryL1Filled = categoryL1 ? !!categoryL1.value : false;
          // return this.category_node && isCategoryL1Filled;
          return this.category_node;
        } else if (this.active_tab === 'SKU Master') {
          return (
            this.article_id &&
            this.brand &&
            this.article_desc &&
            this.category_code &&
            this.selected_type &&
            this.organization &&
            (!this.img_link ||
              (this.img_link && this.isValidUrl(this.img_link))) &&
            this.select_uom &&
            this.serializes
          );
        } else if (this.active_tab === 'Attribute Master') {
          const categoryL1 = this.attribute_masters.find(
            item => item.value === 'article_id'
          );
          const isCategoryL1Filled = categoryL1 ? !!categoryL1.code : false;
          return isCategoryL1Filled;
        } else if (this.active_tab === 'Price Master') {
          const item = this.selected[0];
          return !(item && (this.article_id == item.code || (!this.article_id && !item.code)) &&
            (this.category_code_price == item.category_code ||
            (!this.category_code_price && !item.category_code)) &&
            (this.mrp == item.mrp || (!this.mrp && !item.mrp)) &&
            (this.asp == item.asp || (!this.asp && !item.asp)) &&
            (this.map == item.map || (!this.map && !item.map)) &&
            (this.rent == item.rent_rate_per_month ||
              (!this.rent && !item.rent_rate_per_month)) &&
            (this.security_deposit == item.security_deposit ||
              (!this.security_deposit && !item.security_deposit))
          );
        } else if (this.active_tab === 'BOM Master') {
          return (
            this.article_id_bom &&
            this.bom_details.every(item => item.selected_bom && item.quantity)
          );
        }
      },
      dataTableStyle() {
        if(this.active_tab === 'Price Master'){
          return { height: 'calc(var(--vh, 1vh) * 100 - 368px) !important' }
        }else if(this.active_tab === 'BOM Master'){
          return { height: 'calc(var(--vh, 1vh) * 100 - 345px) !important' }
        }else{
          return { height: 'calc(var(--vh, 1vh) * 100 - 320px) !important' }
        }
      },
    },
    methods: {
      validateEmail() {
        const emails = this.email_id.split(',').map(email => email.trim());
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emails.length === 1 && !emailPattern.test(emails[0])) {
          this.emailError = 'Please enter a valid email';
          this.isEmailValid = false
          return;
        } else {
          this.isEmailValid = true
        }
        for (const email of emails) {
          if (!emailPattern.test(email)) {
            this.emailError = 'Please enter valid email ids separated by commas';
            this.isEmailValid = false
            return;
          } else {
            this.isEmailValid = true
          }
        }
        this.emailError = null;
      },
      loadData(tab, tab_action) {
        if (tab_action) {
          // this.isCategorySelected = false;
          this.search_tag = '';
        }
        this.loading = true;
        this.selected = [];
        this.active_tab = tab;
        this.table_data = [];
        this.page = 1;
        this.totalPages = 1;
        this.$store.commit('setActiveTab',{
          'active_tab' : tab
        })
        this.successPopup = false;
        if (tab == 'Category Master') {
          this.search_label = 'Search by Category Node';
          this.fetchCategMaster();
        } else if (tab == 'SKU Master') {
          this.search_label = 'Search by Article ID';
          this.headers = [
            { title: "Article ID", key: "code",minWidth: "200px"},
            { title: "Brand", key: "brand",minWidth: "200px" },
            { title: "Model Name", key: "item_model_name",minWidth: "200px" },
            { title: "Article Description", key: "sku_description",minWidth: "200px" },
            { title: "Category Code", key: "category_code",minWidth: "200px" },
            { title: "Type Of Item", key: "master_sku_type_name",minWidth: "200px" },
            { title: "Organization", key: "organization",minWidth: "200px" },
            { title: "Images", key: "images",minWidth: "200px" },
            { title: "HSN Code", key: "hsn_code",minWidth: "200px" },
            { title: "UOM", key: "uom",minWidth: "200px" },
            { title: "Serialized", key: "serialize_type",minWidth: "200px"},
            { title: "Warranty Period", key: "warranty_period",minWidth: "200px" },
            { title: "Accessories", key: "accessories",minWidth: "200px" },
            { title: "Article Type", key: "article_type",minWidth: "200px" },
            { title: "Child Article ID", key: "child_article_id",minWidth: "200px" },
            { title: "Set Size", key: "set_size",minWidth: "200px" },
          ];
          this.fetchSkuMaster();
        } else if(tab == 'Attribute Master'){
           this.search_label = 'Search by Article ID'
          this.fetchAtrrMaster();
        } else if(tab == 'Price Master'){
           this.search_label = 'Search by Article ID'
          this.headers = [
            { title: "Article ID", key: "code",minWidth: "200px" },
            { title: "MRP (₹)", key: "mrp",minWidth: "200px"  },
            { title: "ASP (₹)", key: "asp" ,minWidth: "200px" },
            { title: "MAP (₹)", key: "map",minWidth: "200px"  },
            { title: "Rent Rate/Month (₹)", key: "rent_rate_per_month",minWidth: "200px"  },
            { title: "Security Deposit (₹)", key: "security_deposit",minWidth: "200px"  },
         ];
         this.fetchPriceMaster();
        } else if(tab == 'BOM Master'){
           this.search_label = 'Search by Article ID'
           this.page = 1
          this.headers = [
            { title: "Article ID", key: "article_id",minWidth: "200px"  },
            { title: "BOM Article ID", key: "bom_sku",minWidth: "200px"  },
            { title: "UOM", key: "uom",minWidth: "200px"  },
            { title: "Quantity", key: "quantity",minWidth: "200px"  },
            { title: "Production Cost", key: "production_cost",minWidth: "200px"  },
          ];
          this.fetchBomMaster();
          this.getBOMFilterData();
        }
      },
      defineCategoryFunc() {
        this.categoryPopup = true;
        this.category_details = [{category_node : ''}];
      },
      addCategoryNode(){
        this.category_details.push({category_node : ''});
      },
      categoryNodeSubmit(){
        const categoryNodes = this.category_details.map(item => item.category_node);
        this.$httpSecured
          .put(`/api/v2/warehouse/master_categories/set_category_nodes`, {
            category_nodes: categoryNodes,
          })
          .then(response => {
            if (response.data) {
              this.categoryPopup = false;
              this.successPopup = true;
              this.message = response.data.message;
              this.loadData(this.active_tab);
            } else {
              this.number = 0;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.$toast.error(error.response.data.error)
            this.assigneePopup = false;
            this.number = 0;
          });
      },
      addItem(){
          this.addItemPopup = true;
          this.button_action = 'add';
          this.add_item_title = 'Add ' + this.active_tab 
          if(this.active_tab == 'SKU Master'){
            this.article_id = '';
            this.brand = '';
            this.article_desc = '';
            this.category_code = '';
            this.selected_type = '';
            this.organization = '';
            this.img_link = '';
            this.hsn_code = '';
            this.select_uom = null;
            this.serializes = null;
            this.fetchFilterDataSkuMaster();
          } else if(this.active_tab == 'Attribute Master'){
          } else if(this.active_tab == 'Price Master'){
             if (this.selected.length > 0) {
              const selectedItem = this.selected[0];
              // this.price_master_form_data.forEach(field => {
              //   field.value = selectedItem[field.value] || '';
              //   if (field.value === 'id' || field.value === 'code') {
              //     field.disabled = true;
              //   } else {
              //     field.disabled = false;
              //   }
              // });
              this.article_id     = selectedItem.code
              this.category_code_price = selectedItem.category_code
              this.mrp = selectedItem.mrp
              this.asp = selectedItem.asp
              this.map = selectedItem.map
              this.rent = selectedItem.rent_rate_per_month
              this.security_deposit = selectedItem.security_deposit
            }
          } else if(this.active_tab == 'BOM Master'){
            this.bom_details = [{ selected_bom:'', uom:'', quantity:''}];
          }
      },
      editItem(){
        this.addItemPopup = true;
        this.button_action = 'edit';
        this.add_item_title = 'EDIT ' + this.active_tab;
        if(this.active_tab == 'SKU Master'){
          this.article_id = this.selected[0].article_sku;
          this.brand = this.selected[0].brand;
          this.article_desc = this.selected[0].article_desc;
          this.category_code = this.selected[0].category_code;
          this.selected_type = this.selected[0].selected_type;
          this.organization = this.selected[0].organization;
          this.img_link = this.selected[0].img;
          this.hsn_code = this.selected[0].hsn_code;
          this.select_uom = this.selected[0].select_uom;
          this.serializes = this.selected[0].serializes;
        } else if(this.active_tab == 'Attribute Master'){
          this.article_id = this.selected[0].article_sku;
          this.item_type = this.selected[0].item_type;
          this.capacity = this.selected[0].capacity;
          this.size = this.selected[0].size;
          this.ram = this.selected[0].ram;
          this.hdd = this.selected[0].hdd;
          this.processor = this.selected[0].processor;
          this.color = this.selected[0].color;
        } else if(this.active_tab == 'Price Master'){
          this.article_id = this.selected[0].article_sku;
          this.mrp = this.selected[0].mrp;
          this.asp = this.selected[0].asp;
          this.map = this.selected[0].map;
          this.rent = this.selected[0].rent;
        }
      },
      addMore(){
        this.bom_details.push({selected_bom:'', uom:'', quantity:'' });
      },
      deleteItem(index){
        const add_index = index+1
        this.bom_details.splice(add_index,1);
      },
      navigateToFileUpload() {
        if(this.active_tab === 'Category Master'){
          this.$store.commit("setLotIds", {
            lotIds: this.headerText,
            inventoryId: this.active_tab,
            action:'first_tab'
          });
        }else if(this.active_tab === 'SKU Master'){
          this.$store.commit("setLotIds", {
            lotIds: this.headerText,
            inventoryId: this.active_tab,
            action:'second_tab'
          });
        }else if(this.active_tab === 'Attribute Master'){
          this.$store.commit("setLotIds", {
            lotIds: this.headerText,
            inventoryId: this.active_tab,
            action: 'third_tab'
          });
        } else if (this.active_tab === 'Price Master') {
          this.$store.commit("setLotIds", {
            lotIds: this.headerText,
            inventoryId: this.active_tab,
            action: 'fourth_tab'
          });
        } else if (this.active_tab === 'BOM Master') {
          this.$store.commit("setLotIds", {
            lotIds: this.headerText,
            inventoryId: this.active_tab,
            action: 'fifth_tab'
          });
        }
        this.$router.push({ name: "LotFileuploadComm" });
      },
      addNewAttribute() {
        this.new_attribute = '';
        this.newAttributeDialog = true;
      },
      filterListOfButtons() {
        // filter popup
      },
      fetchCategMaster() {
        //call category details api
        // this.isLoading = true;
        this.loading = true;
        const params = {
          tab: "Master Category",
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .get(`/api/v2/warehouse/master_categories/master_configuration_data`, {
              params: params
          })
          .then(response => {
            this.isLoading = false;
            if ( response.data && response.data.category_nodes && response.data.category_nodes.length > 0 ) {
              this.category_details = response.data.category_nodes.map( (node, index) => {
                const isCategoryL1 = node === 'Category L1';
                return {
                  original_code: node,
                  label_name: isCategoryL1 ? `Enter Category Node ${index + 1} *` : `Enter Category Node ${index + 1}`,
                  code: `category_${index + 1}`,
                  key: ''
                };
              }
            );
              this.headers = response.data.category_nodes.map(
                (category, index) => ({
                  title: `Category Node ${index + 1}`,
                  key: category
                })
              );
              this.headers.push({ title: 'Category Code', key: 'cat_code' });
              this.table_data = [];
              this.isCategorySelected = true;
              this.filterPopup = false;
              this.fetchCategoryMasterIndex();
              // this.loading = false;
            } else {
              this.isLoading = false;
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
            this.loading = false;
            this.isLoading = false;
          });
      },
      fetchCategoryMasterIndex() {
        this.loading = true;
        const encodedSearchTag = this.search_tag

        const params = {
          query: encodedSearchTag,
          tab: "Master Category",
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .get(`/api/v2/warehouse/master_categories`, {
            params: params
          })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.master_categories;
              this.table_data.forEach((item, index) => {
                item.id = index;
              });
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.filterPopup = false;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
            this.loading = false;
          });
      },
      fetchSkuMaster() {
        this.loading = true;
        const params = {
          query: this.search_tag,
          page: this.page,
          per_page: this.pageSize,
          tab: "Master Sku"
        };
        this.$httpSecured
          .get(`/api/v2/warehouse/sku_masters`, {
            params: params
          })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.client_sku_masters;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.filterPopup = false;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
            this.loading = false;
          });
      },
      fetchAtrrMaster() {
        this.loading = true;
        const params = {
          query: this.search_tag,
          page: this.page,
          per_page: this.pageSize,
          tab: "Master Attribute"
        };
        this.$httpSecured
          .get(`/api/v2/warehouse/attribute_masters`, {
            params: params
          })
          .then(response => {
            if (response.data) {
              this.table_data = [];
              response.data.attribute_masters.forEach((item, index) => {
                const temp = { ...item, id: index };
                this.table_data.push(temp);
              });
              this.attribute_masters = response.data.attribute_masters;
              if (this.attribute_masters.length > 0) {
                this.headers = Object.keys(this.attribute_masters[0]).map(
                  key => ({
                    title: this.capitalizeHeader(key),
                    key: key
                  })
                );
              }
              if (this.attribute_masters.length > 0) {
                this.attribute_masters = Object.keys(
                  this.attribute_masters[0]
                ).map(key => ({
                  title:
                    key === "article_id"
                      ? `Enter Artcle ID *`
                      : `Enter ${this.capitalizeHeader(key)}`,
                  key: key,
                  code: ""
                }));
              }
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;

              this.filterPopup = false;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
            this.loading = false;
          });
      },
      capitalizeHeader(header) {
        const part = header.split("_");
        var name = "";
        part.forEach((item, index) => {
          if (index != 0) name += " ";
          if (item == "id") name += "ID";
          else name += item.charAt(0).toUpperCase() + item.slice(1);
        });
        return name;
      },
      fetchPriceMaster() {
        this.loading = true;
        const params = {
          query: this.search_tag,
          page: this.page,
          per_page: this.pageSize,
          tab: "Master Price"
        };
        this.$httpSecured
          .get(`/api/v2/warehouse/price_masters`, {
            params: params
          })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.price_masters;
              // this.price_master_form_data = response.data.price_masters;

              // if (this.price_master_form_data.length > 0) {
              //   this.price_master_form_data = Object.keys(this.price_master_form_data[0])
              //     .filter(key => key !== 'security_deposit')
              //     .map(key => ({
              //       text: `Enter ${this.formatKeyName(key)}`,
              //       value: key,
              //       code: '',
              //       disabled: key === 'id' || key === 'code'
              //     }));
              // }

              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;

              this.liquidation_benchmark_price =
                response.data.liquidation_benchmark_price;
              this.recovery_benchmark_price =
                response.data.recovery_benchmark_price;
              this.filterPopup = false;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
            this.loading = false;
          });
      },
      formatKeyName(key) {
        const keyMap = {
          code: "Code",
          mrp: "MRP",
          category_code: "Category Code",
          asp: "ASP",
          map: "MAP",
          rent_rate_per_month: "Rent Rate Per Month"
        };
        return keyMap[key] || this.capitalizeHeader(key);
      },
      fetchBomMaster() {
        this.loading = true;
        const params = {
          query: this.search_tag,
          page: this.page,
          per_page: this.BomPageSize,
          tab: "Master Bom"
        };
        this.isLoading = true;
        this.table_data = [];
        this.$httpSecured
          .get(`/api/v2/warehouse/bom_masters`, {
            params: params
          })
          .then(response => {
            if (response.data) {
              this.bom_result = response.data.client_sku_masters;
              this.isLoading = false;
              // result.forEach(item=>{
              //   item.bom_data.forEach((bom,index) =>{
              //     if(index == 0)
              //       this.table_data.push({ id: item.id, article_id : item.article_id, bom_sku : bom.child_sku_code, uom : bom.uom, quantity : bom.quantity, production_cost : item.production_cost === 0 ? 'N/A' : item.production_cost, show_select : false})
              //     else
              //       this.table_data.push({ id: item.id, article_id : '', bom_sku : bom.child_sku_code, uom : bom.uom, quantity : bom.quantity, production_cost : '', show_select : false})
              //   })
              // })
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.filterPopup = false;
              this.loading = false;
            } else {
              this.loading = false;
              this.isLoading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
            this.loading = false;
            this.isLoading = false;
          });
      },
      openPopup() {
        this.number = 0;
        this.downloadDialog = true;
        this.email_id = this.$store.state.currentUser.email;
        this.validateEmail(this.email_id)
      },
      downloadDocument(value) {
        this.number++;
        if (!this.selected) {
          this.downloadDialog = true;
          this.validateEmail(this.email_id)
        }
        const tabMapping = {
          "Category Master": {
            endpoint: "/api/v2/warehouse/master_categories/download",
            tab: "Master Category",
            selectedParam: "cat_codes",
            selectedValue: item => item.cat_code,
          },
          "SKU Master": {
            endpoint: "/api/v2/warehouse/sku_masters/download",
            tab: "Master Sku",
            selectedParam: "ids",
            selectedValue: item => item.id,
          },
          "Attribute Master": {
            endpoint: "/api/v2/warehouse/attribute_masters/download",
            tab: "Master Attribute",
            selectedParam: "codes",
            selectedValue: item => item.article_id,
          },
          "Price Master": {
            endpoint: "/api/v2/warehouse/price_masters/download",
            tab: "Master Price",
            selectedParam: "ids",
            selectedValue: item => item.id,
          },
          "BOM Master": {
            endpoint: "/api/v2/warehouse/bom_masters/download",
            tab: "Master Bom",
            selectedParam: "article_ids",
            selectedValue: item => item.article_id,
          },
        };
        const params = {};
        if (value === 'submit') {
          var { endpoint, tab } = tabMapping[this.active_tab];
          params.tab = tab;
          params.email_ids = this.email_id;
        } else {
          var { endpoint, tab, selectedParam, selectedValue } = tabMapping[this.active_tab];
          params.tab = tab;
          params[selectedParam] = this.selected.map(selectedValue).filter(Boolean).join(",");
        }
        this.$httpSecured
          .get(endpoint, { params: params })
          .then(response => {
            if (response.data) {
              if (value === 'submit') {
                this.snackbar = true;
                this.downloadDialog = false;
                this.email_id = '';
                this.number = 0;
                this.snackbar = {
                  color: "success",
                  icon: "mdi-check-circle",
                  mode: "multi-line",
                  position: "top",
                  timeout: 3000,
                  title: 'Success',
                  text: response.data.message,
                  visible: true
                };
              } else {
                const link = document.createElement("a");
                link.href = response.data.url;
                link.target = "_blank";
                link.download = "inventory.csv";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.successPopup = true;
                this.message = this.active_tab + "(CSV File) Downloaded Successfully";
                this.selected = [];
                this.number = 0;
              }
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
              this.selected = [];
              this.number = 0;
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
            this.number = 0;
          });
      },
      showAlert(alert_type, alert_message) {
        this.scrollToTop();
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      },
      handlePageSizeChange(size) {
        this.page = 1;
        if (this.active_tab == "Category Master") {
          this.pageSize = size;
          this.fetchCategMaster();
        } else if (this.active_tab == "SKU Master") {
          this.pageSize = size;
          this.fetchSkuMaster();
        } else if (this.active_tab == "Attribute Master") {
          this.pageSize = size;
          this.fetchAtrrMaster();
        } else if (this.active_tab == "Price Master") {
          this.pageSize = size;
          this.fetchPriceMaster();
        } else {
          this.BomPageSize = size;
          this.fetchBomMaster();
        }
      },
      handlePageChange(value) {
        this.page = value;
        if (this.active_tab == "Category Master") {
          this.fetchCategMaster();
        } else if (this.active_tab == "SKU Master") {
          this.fetchSkuMaster();
        } else if (this.active_tab == "Attribute Master") {
          this.fetchAtrrMaster();
        } else if (this.active_tab == "Price Master") {
          this.fetchPriceMaster();
        } else {
          this.fetchBomMaster();
        }
      },
      submitCategoryMaster() {
        let end_point;
        if (this.active_tab === "Category Master") {
          const client_category = {};
          this.category_details.forEach(item => {
            client_category[item.code] = item.value;
          });
          client_category.cat_code = this.category_node;
          end_point = this.$httpSecured.post(
            "/api/v2/warehouse/master_categories",
            { client_category }
          );
        } else if (this.active_tab === "SKU Master") {
          const temp = [];
          temp.push(this.img_link);
          const client_sku_master = {
            code: this.article_id,
            brand: this.brand,
            sku_description: this.article_desc,
            category_code: this.category_code,
            master_sku_type_id: this.selected_type,
            master_sku_type_name: "Consumables",
            organization: this.organization,
            // "images": temp,
            hsn_code: this.hsn_code,
            uom: this.select_uom,
            serialize_type: this.serializes
          };
          if (this.img_link) client_sku_master.images = temp;
          end_point = this.$httpSecured.post("/api/v2/warehouse/sku_masters", {
            client_sku_master
          });
        } else if (this.active_tab === "Attribute Master") {
          let article_value = "";
          const attribute_details = {};
          this.attribute_masters.forEach(item => {
            if (item.value !== "article_id") {
              attribute_details[item.value] = item.code;
            } else {
              article_value = item.code;
            }
          });
          const payload = {
            article_id: article_value,
            attribute_details
          };
          end_point = this.$httpSecured.post(
            "/api/v2/warehouse/attribute_masters",
            payload
          );
        } else if (this.active_tab === "BOM Master") {
          const bom_articles = this.bom_details.map(item => ({
            bom_article_id: item.selected_bom,
            quantity: item.quantity
          }));
          const payload = {
            id: this.article_id_bom,
            production_cost: this.production_cost,
            bom_articles
          };
          end_point = this.$httpSecured.post(
            "/api/v2/warehouse/bom_masters",
            payload
          );
        } else if (this.active_tab === "Price Master") {
          const payload = {
            mrp: this.mrp,
            asp: this.asp,
            map: this.map,
            rent_rate_per_month: this.rent,
            security_deposit: this.security_deposit
          };
          end_point = this.$httpSecured.put(
            `/api/v2/warehouse/price_masters/${this.selected[0].id}`,
            payload
          );
        }

        if (end_point) {
          end_point.then(response => {
              if (response.data) {
                this.clearData();
                this.successPopup = true;
                this.message = response.data.message;
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              // this.showAlert("error", "Something went wrong from Network" + error);
              this.$toast.error(error.response.data.message ? error.response.data.message : error.response.data.error);
              this.loading = false;
            });
        }
      },
      clearData() {
        this.addItemPopup = false;
        this.$refs.addFormData.reset();
        if (this.active_tab === "Category Master") {
          this.category_details = this.category_details.map(item => ({
            ...item,
            value: ""
          }));
          this.category_node = "";
        } else if (this.active_tab === "SKU Master") {
          this.article_id = "";
          this.brand = "";
          this.article_desc = "";
          this.category_code = "";
          this.selected_type = "";
          this.organization = "";
          this.img_link = "";
          this.hsn_code = "";
          this.select_uom = null;
          this.serializes = null;
        } else if (this.active_tab === "Attribute Master") {
          this.attribute_masters = this.attribute_masters.map(item => ({
            ...item,
            code: ""
          }));
        } else if (this.active_tab === "Price Master") {
          this.article_id = "";
          this.category_code_price = "";
          this.mrp = "";
          this.asp = "";
          this.map = "";
          this.rent = "";
          this.security_deposit = "";
        } else if (this.active_tab === "Price Master") {
          this.bom_details = [{ selected_bom: "", uom: "", quantity: "" }];
          this.article_id_bom = "";
          this.production_cost = "";
        }
      },
      fetchFilterDataSkuMaster() {
        this.$httpSecured
          .get(`/api/v2/warehouse/sku_masters/get_filter_data`)
          .then(response => {
            if (response.data) {
              this.category_list = response.data.category_code;
              this.type_list = response.data.sku_type;
              this.uom_list = response.data.uom.map(uom => uom[1]);
              this.org_list = response.data.organization;
              this.serial_list = response.data.serialized.map(item => Object.keys(item)[0]);
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
            this.loading = false;
          });
      },
      isValidUrl(url) {
        try {
          new URL(url);
          return true;
        } catch (_) {
          return false;
        }
      },
      submitNewAttribute() {
        this.number++;
        this.$httpSecured.post('/api/v2/warehouse/attribute_masters/create_attribute', {
            "attribute_name": this.new_attribute
          })
          .then(response => {
            if (response.data) {
              this.newAttributeDialog = false;
              this.successPopup = true;
              this.message = response.data.message;
              this.new_attribute = "";
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.number = 0;
            this.loading = false;
          });
      },
      openLiquidationBMP(label) {
        this.dialog_label_name = label;
        this.liquidation_bmp = "";
        this.liquidationBMPPopup = true;
        this.$httpSecured
          .get(`/api/v2/warehouse/price_masters/filter_data`)
          .then(response => {
            if (response.data) {
              this.liquidation_bmp_items = response.data.data;
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
          });
      },
      updateBMPLiquidation() {
        const formData = new FormData();
        if (this.dialog_label_name === "Liquidation BMP") {
          formData.append("liquidation_benchmark_price", this.liquidation_bmp);
        } else {
          formData.append("recovery_benchmark_price", this.liquidation_bmp);
        }
        this.$httpSecured
          .put(`/api/v2/warehouse/price_masters/set_benchmark_price`, formData)
          .then(response => {
            if (response.data) {
              this.liquidationBMPPopup = false;
              this.successPopup = true;
              this.message = "Successfully updated";
              this.liquidation_bmp = "";
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
          });
      },
      getBOMFilterData(event, condition) {
        let params = {};
        if (event) {
          let value_type = event.target.value;
          if (condition === "article" && value_type.length > 1) {
            params.search_text = value_type;
            params.with_search = condition;
          } else if (condition === "bom_article" && value_type.length > 1) {
            params.search_text = value_type;
            params.with_search = condition;
          } else if (value_type.length < 1) {
            this.articleId_list = this.store_art;
            this.bom_list = this.store_bom;
            return;
          }
        }
        this.$httpSecured
          .get(`/api/v2/warehouse/bom_masters/get_filter_data`, {
            params: params
          })
          .then(response => {
            if (response.data) {
              if (condition === "article") {
                this.articleId_list = response.data.data;
              } else if (condition === "bom_article") {
                this.bom_list = response.data.data;
              } else {
                this.articleId_list = response.data.article_ids;
                this.store_art = response.data.article_ids;
                this.bom_list = response.data.bom_article_ids;
                this.store_bom = response.data.bom_article_ids;
              }
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
          });
      },
      selectItem(item, row) {
        this.select_all = this.bom_result.every(item =>
          item.bom_data.every(data => data.show_select)
        );
        if (item.show_select) {
          this.selected.push(row);
        } else {
          this.selected.pop(row);
          this.selected = this.selected.filter(obj => obj.id !== item.id);
        }
      },
      getUOMValue(selectedBom, index) {
        const foundItem = this.bom_list.find(item => item.id === selectedBom);
        if (foundItem) {
          this.$set(this.bom_details, index, {
            ...this.bom_details[index],
            uom: foundItem.uom
          });
        } else {
          this.$set(this.bom_details, index, {
            ...this.bom_details[index],
            uom: ""
          });
        }
      },
      openImagePopup(item) {
        (this.imagesPopup = true), (this.imagesList = item.images);
      },
      cancelSuccessMessage() {
        this.successPopup = false;
        this.loadData(this.active_tab);
      },
      update_all_selectall() {
    this.bom_result.forEach(item => {
        item.bom_data.forEach(data => {
            data.show_select = this.select_all;
        });
    });
    if (this.select_all) {
        this.selected = this.bom_result.map(item => item.bom_data).flat();
    } else {
        this.selected = [];
    }
}
    },
  }
</script>
<style scoped>
  .custom-control_outlined button {
    min-height: 56px;
    border-width: 1px;
    border-color: rgba(0,0,0,.42);
    border-style: solid;
  }
  .v-dialog__content:has(.filter-data){
    justify-content: right;
    align-items: baseline;
    top: 13rem;
  }
  .item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}
@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}

@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}
.update-marp-style{
  height : 42px;
  background-color: #F0F0F1;
}
.inside-row-style{
  padding: 10px 30px;
}
.pencil-style{
  color: #2E86C1;
  cursor: pointer;
}
table{
  width: 98% !important;
  margin : 0px 12px !important;
}
th{
  font-size: 0.75rem!important;
  color : #00000099!important;
}
.top_border{
  border-top: 1px solid #E5E7EB;
}
.header_border{
  border-bottom: 1px solid #E5E7EB;
}
tr{
  height : 48px !important;
} 
.table-container{
  /* height : 72vh; */
  overflow-y: auto;
  height: calc(var(--vh, 1vh) * 100 - 345px) !important;
}
thead th{
  position : sticky;
  top : 0;
  background-color: #ffff;
}
tr.row_data:hover{
  background-color: lightgrey;
}
.image-container {
    position: relative;
    display: inline-block;
}
.image-rad-size{
  width: 186px;
  height: 184px;
  border-radius: 8px;
}
</style>